import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    ShowLess: {
        id: 'Components.CollapsibleText.ShowLess',
        defaultMessage: 'show less',
    },
    ShowMore: {
        id: 'Components.CollapsibleText.ShowMore',
        defaultMessage: 'show more',
    },
});
